import { useEffect, useState } from 'react';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { api, ErrorApi } from '../api';
import Ayuda from '../ui/Ayuda';

/* =====================================================================
   EL CATÁLOGO QUE APRENDE · R-AE1 (DIRECTRIZ-ALTA-POR-ESCANEO F6)
   =====================================================================
   Un interruptor por empresa, en Administración. Encendido por omisión
   (decisión por omisión de la directriz). Solo cambia lo que se aporta a
   partir de ahora; lo que ya aprendió el catálogo se queda.
   ===================================================================== */
export default function AjustesAltaEscaneo() {
  const [aprende, setAprende] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/alta-escaneo/ajustes').then((r) => setAprende(Boolean(r.aprende)))
      .catch((e) => setError(e instanceof ErrorApi ? e.message : 'No hay conexión con el servidor. Vuelve a abrir la pantalla.'));
  }, []);

  async function cambiar(valor) {
    setGuardando(true);
    setError(null);
    setMensaje(null);
    try {
      const r = await api.put('/alta-escaneo/ajustes', { aprende: valor });
      setAprende(Boolean(r.aprende));
      setMensaje(r.aprende ? 'Listo: el catálogo de TEGO aprende de lo que das de alta.'
        : 'Listo: lo que das de alta ya no se aporta al catálogo de TEGO.');
    } catch (e) {
      setError(e instanceof ErrorApi ? e.message : 'No hay conexión con el servidor. Vuelve a intentarlo.');
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div className="space-y-4" data-alta-escaneo="ajustes">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">Catálogo que aprende</h2>
        <p className="text-sm text-gray-500 mt-0.5">Si lo que das de alta escaneando ayuda a que TEGO reconozca productos.</p>
      </div>
      <Ayuda id="alta_escaneo.ajustes.pantalla" />
      {aprende === null && !error && (
        <p className="text-sm text-gray-600 inline-flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Leyendo…</p>
      )}
      {aprende !== null && (
        <label className="flex items-start gap-3 rounded-xl border border-gray-200 p-3 min-h-12">
          <input type="checkbox" className="mt-1 h-5 w-5" checked={aprende} disabled={guardando}
            onChange={(e) => cambiar(e.target.checked)} />
          <span>
            <span className="block font-semibold text-gray-900">Ayudar al catálogo de TEGO</span>
            <Ayuda id="alta_escaneo.ajustes.interruptor" />
          </span>
        </label>
      )}
      {mensaje && <p className="text-sm text-green-800 inline-flex items-center gap-2"><CheckCircle2 className="h-4 w-4" aria-hidden="true" />{mensaje}</p>}
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
    </div>
  );
}
